import { createNullableContext } from '~/common/contexts/nullableContext';
import { AuthApi } from './types';

export const AuthApiContext = createNullableContext<AuthApi>();
